module.exports = __webpack_public_path__ + "img/word.a923294a.jpeg";